import { getProducts } from '@front/common/endpoints'
import { computed } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'

import { INSERT_PRODUCTS } from './constants'

const useProduct = () => {
  const store = useStore()

  const [onFetchProductsSuccess, fetchProductsState, fetchProducts]: any[] =
    useApiState(getProducts)

  const products = computed(() => {
    return store.getters['product/get']
  })

  onFetchProductsSuccess((data) => {
    store.commit(INSERT_PRODUCTS, data)
  })

  return {
    products,
    fetchProductsState,
    fetchProducts,
  }
}

export default useProduct
